/* eslint-disable */
var $ = window.jQuery = require('jquery');
import {
  bus
} from '../../main';
import toast from '../../services/toast';
import {
  mapGetters,
  mapState
} from 'vuex';
export default {
  name: 'section-file-edit',
  components: {},
  props: ['sectionFileID'],
  data() {
    return {
      section: "",
      file: null,
      name: '',
      description: '',
      submitted: false,
      fileid: '',
      selectedFile: '',
      id: '',
      editSectionFile: '',
      uploadFileName: ''
    }
  },
  computed: {
    ...mapGetters([
      'getsectionbycourseIDState',
      'getsectionFilesState'
    ]),
    editSectionFileFun() {
      this.$store.dispatch('get_course_section_files_id', {
        id: this.sectionFileID
      }).then((res) => {
        this.name = this.$store.getters.getsectionFilesState.data.name;
        //this.uploadFileName = this.$store.getters.getsectionFilesState.data.name;
        this.description = this.$store.getters.getsectionFilesState.data.description;
        this.selectedFile = this.$store.getters.getsectionFilesState.data.file;
        setTimeout(()=>{
          CKEDITOR.instances['update_section_file_desc'].setData(this.description);
        },100)
        console.log(this.$store.getters.getsectionFilesState.data, this.file);
      }).catch((err) => {})
    },

  },
  mounted() {
    this.editSectionFileFun
    console.log(this.$store.getters.getsectionFilesState.data, 'File details ========')
    this.createEditor()
  },
  methods: {
    createEditor() {
      CKEDITOR.replace('update_section_file_desc',{
        extraPlugins: 'mathjax',
        mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
        height:150,
      });
      CKEDITOR.instances['update_section_file_desc'].on('change', () => {
        var content1Length = CKEDITOR.instances['update_section_file_desc'].getData().replace(/<[^>]*>/gi, '').length;
        if(content1Length > 0){
          $('.custom_editor_for_option #update_section_file_desc').attr('aria-invalid', 'false')
          $('.custom_editor_for_option #update_section_file_desc').removeClass('is-invalid')
          this.description = CKEDITOR.instances['update_section_file_desc'].getData()
        }else{
          $('.custom_editor_for_option #update_section_file_desc').attr('aria-invalid', 'true')
          $('.custom_editor_for_option #update_section_file_desc').addClass('is-invalid')
          this.description = ''
        }
      })
    },
    getCourseDetailsAgain() {
      this.$store.dispatch('sectionbycourseId', {
        id: this.$route.params.id
      }).then((res) => {
        bus.$emit('hideEditSectionFilePopup', false);

      }).catch((err) => {})
    },
    handleFileUpload(event) {
      if (event.target.files && event.target.files.length > 0) {
        this.file = event.target.files[0];
        this.files = this.$refs.file.files[0];
        this.filesSize = this.$refs.file.files[0].size;
        this.name = this.files.name
        //this.uploadFileName = this.files.name
      }
    },
    validateFileBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          let formData = new FormData();
          formData.append('description', this.description);
          formData.append('name', this.name);
          if (this.files) {
            formData.append('file', this.files);
          }
          //
          this.$store.dispatch('edit_course_section_files_id', {
              data: {
                formdata: formData,
                id: this.sectionFileID
              }
            })
            .then((res) => {
              if (res.status == '200') {
                this.getCourseDetailsAgain();
                toast.success(res.data.msg);
              }
            })
            .catch((err) => {})
          return
        }
      });
    }

  }
}